import React from 'react';
import Box from '@mui/material/Box';
import KeyValueLabel from '../../labels/KeyValueLabel/KeyValueLabel';
import StatusLabel from '../../labels/StatusLabel/StatusLabel';
import InfoSign from '../../InfoSign/InfoSign';
import { useWindowSize } from '../../../../utils/hooks';
import { responsiveSizeTimesheet } from '../../../../utils/constants';
import classes from './HeaderWithStatus.module.scss';
import InfoIcon from '../../Icons/InfoIcon';

export default function HeaderWithStatus({ data, leftContent, keyValueLabel = [], actionsContainer, isApprover }) {
  const size = useWindowSize();
  return (
    <div className={classes.container}>
      <div className={classes.leftContainer}>{leftContent}</div>
      <div className={classes.rightContainer}>
        <div className={isApprover ? classes.statusApproverWrapper : classes.statusWrapper}>
          {size.width > responsiveSizeTimesheet && (
            <InfoSign text={isApprover && `${data?.User?.FirstName} ${data?.User?.LastName}`} icon={<InfoIcon />}>
              <Box
                sx={{
                  width: 'max-content',
                  padding: '32px 24px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'flex-start',
                  gap: '14px',
                  backgroundColor: '#F6F7F9',
                  boxShadow: size.width > responsiveSizeTimesheet ? '0 4px 4px rgba(0, 0, 0, 0.25)' : 'none',
                  borderRadius: '20px'
                }}
              >
                {keyValueLabel?.map((item) => {
                  return <KeyValueLabel key={item?.label} label={item?.label} value={item?.value} />;
                })}
              </Box>
            </InfoSign>
          )}
          <KeyValueLabel
            label=""
            value={
              <StatusLabel
                type={data?.Status?.Status.toLowerCase()}
                text={data?.Status?.Status}
                isApprover={isApprover}
              />
            }
          />
        </div>
        {actionsContainer}
      </div>
    </div>
  );
}
